module.exports = __webpack_public_path__ + "img/swiper2Img.e0cc3e26.png";